import type { SVGProps } from 'react';

const SvgFanRanking02 = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_2049_19659)'>
      <path
        d='M12.3392 11.8831C12.5987 11.5886 12.804 11.3328 12.9545 11.116C13.1055 10.8997 13.2182 10.7068 13.2937 10.5374C13.3692 10.3684 13.4173 10.217 13.4381 10.0828C13.4589 9.94848 13.4697 9.82056 13.4697 9.69897V9.59497C13.4697 9.22241 13.3296 8.92993 13.0488 8.71753C12.7681 8.50513 12.3892 8.39917 11.9122 8.39917C11.7442 8.39917 11.5748 8.4187 11.4031 8.45776C11.2314 8.49634 11.062 8.56811 10.8945 8.67212C10.727 8.77612 10.5637 8.91723 10.4047 9.09448C10.2452 9.27222 10.0905 9.49536 9.93996 9.76392L8.98497 9.1272C9.09397 8.92798 9.22797 8.71753 9.38697 8.49634C9.54598 8.27563 9.74085 8.07202 9.9711 7.8855C10.2013 7.69946 10.4736 7.54565 10.7878 7.42407C11.1016 7.30298 11.4682 7.24194 11.8867 7.24194C12.3472 7.24194 12.7535 7.30054 13.1055 7.41772C13.457 7.53442 13.7523 7.69702 13.9911 7.90503C14.2298 8.11304 14.4096 8.36206 14.5313 8.65259C14.6526 8.94311 14.7135 9.25708 14.7135 9.59497V9.72486C14.7135 10.2366 14.5832 10.7175 14.3237 11.1682C14.0642 11.6189 13.7292 12.0696 13.3187 12.5203L10.4925 15.6399H15.04V16.7581H8.95996V15.679L12.3392 11.8831Z'
        fill='#CB4DFF'
      />
      <path
        d='M17.8402 18.7329C18.6648 19.2292 19.179 19.5898 19.3517 19.8113C19.5243 20.0327 19.4843 20.1934 19.2896 20.2567C19.0948 20.3201 18.3723 20.5636 17.4737 20.2802C16.9767 20.1235 15.8607 19.4933 16.1316 19.3811C16.4026 19.2689 17.8402 18.7329 17.8402 18.7329Z'
        fill='#CB4DFF'
      />
      <path
        d='M6.15986 18.7329C5.33525 19.2292 4.82105 19.5898 4.64841 19.8113C4.47577 20.0327 4.51579 20.1934 4.71054 20.2567C4.90529 20.3201 5.62777 20.5636 6.52638 20.2802C7.02343 20.1235 8.13938 19.4933 7.86847 19.3811C7.59755 19.2689 6.15986 18.7329 6.15986 18.7329Z'
        fill='#CB4DFF'
      />
      <path
        d='M19.66 16.5051C20.8497 16.6876 21.6116 16.8682 21.9066 17.06C22.2016 17.2517 22.2161 17.4841 22.0056 17.6768C21.7952 17.8695 20.4808 18.749 19.8219 18.7327C19.1631 18.7165 17.909 17.8259 18.1924 17.5265C18.4757 17.227 19.66 16.5051 19.66 16.5051Z'
        fill='#A100FF'
      />
      <path
        d='M19.2889 16.7749C20.4786 16.9574 21.2405 17.138 21.5355 17.3297C21.8305 17.5215 21.845 17.7539 21.6345 17.9466C21.4241 18.1393 20.1097 19.0188 19.4508 19.0025C18.792 18.9862 17.538 18.0957 17.8213 17.7962C18.1046 17.4968 19.2889 16.7749 19.2889 16.7749Z'
        fill='#CB4DFF'
      />
      <path
        d='M4.33964 16.5051C3.1499 16.6876 2.38804 16.8682 2.09302 17.06C1.798 17.2517 1.78356 17.4841 1.99399 17.6768C2.20441 17.8695 3.51885 18.749 4.17768 18.7327C4.8365 18.7165 6.09056 17.8259 5.80723 17.5265C5.52389 17.227 4.33964 16.5051 4.33964 16.5051Z'
        fill='#A100FF'
      />
      <path
        d='M4.71171 16.7749C3.52197 16.9574 2.76011 17.138 2.46509 17.3297C2.17007 17.5215 2.15563 17.7539 2.36606 17.9466C2.57648 18.1393 3.89092 19.0188 4.54975 19.0025C5.20857 18.9862 6.46263 18.0957 6.1793 17.7962C5.89596 17.4968 4.71171 16.7749 4.71171 16.7749Z'
        fill='#CB4DFF'
      />
      <path
        d='M19.8586 11.9375C21.5013 11.9811 23.3354 12.2438 23.4793 12.3607C23.6595 12.5069 23.7577 13.0684 23.3991 13.5461C23.0405 14.0239 21.7407 15.3461 20.0847 15.2952C19.8166 15.287 19.5599 15.2493 19.3179 15.1919C19.266 15.1796 19.8133 11.9363 19.8586 11.9375Z'
        fill='#763DBF'
      />
      <path
        d='M20.0336 13.4262C20.7179 13.4396 22.1686 13.2717 22.4774 13.1581C22.7863 13.0445 23.0223 13.1929 22.9361 13.5752C22.8499 13.9575 21.7264 15.831 20.3569 15.7617C18.9873 15.6925 20.0336 13.4262 20.0336 13.4262Z'
        fill='#A100FF'
      />
      <path
        d='M19.8269 13.7637C20.4986 13.7976 21.9168 13.6879 22.2164 13.5926C22.5161 13.4973 22.7519 13.6419 22.6786 13.9926C22.6053 14.3434 21.5581 16.0399 20.2126 15.9328C18.867 15.8257 19.8269 13.7637 19.8269 13.7637Z'
        fill='#CB4DFF'
      />
      <path
        d='M4.14116 11.9375C2.49839 11.9811 0.66435 12.2438 0.520399 12.3607C0.340226 12.5069 0.241991 13.0684 0.600588 13.5461C0.95919 14.0239 2.25901 15.3461 3.91498 15.2952C4.18311 15.287 4.43982 15.2493 4.68179 15.1919C4.73367 15.1796 4.18645 11.9363 4.14116 11.9375Z'
        fill='#763DBF'
      />
      <path
        d='M3.96731 13.4262C3.28294 13.4396 1.83231 13.2717 1.52346 13.1581C1.21461 13.0445 0.978634 13.1929 1.06481 13.5752C1.15099 13.9575 2.27451 15.831 3.64403 15.7617C5.01356 15.6925 3.96731 13.4262 3.96731 13.4262Z'
        fill='#A100FF'
      />
      <path
        d='M4.1728 13.7637C3.50105 13.7976 2.08292 13.6879 1.78328 13.5926C1.48363 13.4973 1.24778 13.6419 1.3211 13.9926C1.39442 14.3434 2.44159 16.0399 3.78712 15.9328C5.13265 15.8257 4.1728 13.7637 4.1728 13.7637Z'
        fill='#CB4DFF'
      />
      <path
        d='M4.85474 9.26354C4.85474 9.26354 4.76838 9.22129 4.72475 9.20027C2.9612 8.35017 0.727764 7.60594 0.512639 7.65541C0.257872 7.714 -0.110123 8.2413 0.0314124 8.91507C0.172948 9.58884 0.880634 11.6102 2.60739 12.4011C3.19307 12.6694 3.78874 12.7793 4.32025 12.8073C4.36284 12.8096 4.44674 12.8125 4.44674 12.8125L4.34905 11.2572L4.85474 9.26354Z'
        fill='#763DBF'
      />
      <path
        d='M4.31751 10.1419C3.27794 9.94192 1.55537 9.43467 1.18223 9.22473C0.774559 8.99536 0.396312 9.13727 0.410546 9.67414C0.424779 10.211 1.4933 13.0148 3.46368 13.2591C3.78793 13.2993 4.03588 13.2432 4.22388 13.1213C4.26891 13.0921 4.33493 10.1453 4.31751 10.1419Z'
        fill='#A100FF'
      />
      <path
        d='M4.34877 10.6124C3.35124 10.4266 1.71717 9.9607 1.36213 9.7658C0.972166 9.55171 0.608912 9.6869 0.620382 10.1921C0.631852 10.6973 1.64501 13.3312 3.53331 13.5526C3.84412 13.589 4.08213 13.535 4.2629 13.4195C4.29157 13.4011 4.3698 10.6163 4.34877 10.6124Z'
        fill='#CB4DFF'
      />
      <path
        d='M19.1455 9.26354C19.1455 9.26354 19.2319 9.22129 19.2755 9.20027C21.039 8.35017 23.2725 7.60594 23.4876 7.65541C23.7424 7.714 24.1104 8.2413 23.9688 8.91507C23.8273 9.58884 23.1196 11.6102 21.3929 12.4011C20.8072 12.6694 20.2115 12.7793 19.68 12.8073C19.6374 12.8096 19.5535 12.8125 19.5535 12.8125L19.6512 11.2572L19.1455 9.26354Z'
        fill='#763DBF'
      />
      <path
        d='M19.6825 10.1419C20.7221 9.94192 22.4447 9.43467 22.8178 9.22473C23.2255 8.99536 23.6037 9.13727 23.5895 9.67414C23.5753 10.211 22.5068 13.0148 20.5364 13.2591C20.2121 13.2993 19.9642 13.2432 19.7762 13.1213C19.7311 13.0921 19.6651 10.1453 19.6825 10.1419Z'
        fill='#A100FF'
      />
      <path
        d='M19.651 10.6124C20.6485 10.4266 22.2826 9.9607 22.6376 9.7658C23.0276 9.55171 23.3909 9.6869 23.3794 10.1921C23.3679 10.6973 22.3548 13.3312 20.4665 13.5526C20.1557 13.589 19.9176 13.535 19.7369 13.4195C19.7082 13.4011 19.63 10.6163 19.651 10.6124Z'
        fill='#CB4DFF'
      />
      <path
        d='M6.05343 5.40509C4.75923 4.89832 2.17084 3.4866 1.68114 3.05223C1.19144 2.61785 0.631791 2.69025 0.491879 3.41421C0.351967 4.13816 0.981576 8.22851 3.60494 9.16966C4.03688 9.32462 4.39297 9.32649 4.68646 9.22149C4.73978 9.20241 5.97697 6.80008 5.98848 6.70504C6.07514 5.9894 6.05343 5.40509 6.05343 5.40509Z'
        fill='#763DBF'
      />
      <path
        d='M5.15751 5.80365C4.02932 5.61852 1.70036 4.91368 1.22925 4.63977C0.758135 4.36585 0.323426 4.53076 0.343439 5.1651C0.363451 5.79944 1.61311 9.11934 3.88427 9.42226C6.15543 9.72519 5.15751 5.80365 5.15751 5.80365Z'
        fill='#A100FF'
      />
      <path
        d='M5.04067 6.3368C3.99663 6.18361 1.84432 5.58117 1.41013 5.34281C0.975948 5.10444 0.571509 5.25497 0.584279 5.81743C0.597049 6.37989 1.72509 9.31242 3.82749 9.55893C5.92989 9.80544 5.04067 6.3368 5.04067 6.3368Z'
        fill='#CB4DFF'
      />
      <path
        d='M17.9458 5.40509C19.24 4.89832 21.8284 3.4866 22.3181 3.05223C22.8078 2.61785 23.3674 2.69025 23.5073 3.41421C23.6472 4.13817 23.0176 8.22851 20.3943 9.16966C19.9623 9.32462 19.6062 9.32649 19.3127 9.22149C19.2594 9.20241 18.0222 6.80008 18.0107 6.70504C17.9241 5.9894 17.9458 5.40509 17.9458 5.40509Z'
        fill='#763DBF'
      />
      <path
        d='M18.8423 5.80365C19.9705 5.61852 22.2995 4.91368 22.7706 4.63977C23.2417 4.36585 23.6764 4.53076 23.6564 5.1651C23.6364 5.79944 22.3867 9.11934 20.1156 9.42226C17.8444 9.72519 18.8423 5.80365 18.8423 5.80365Z'
        fill='#A100FF'
      />
      <path
        d='M18.9592 6.3368C20.0032 6.18361 22.1556 5.58117 22.5897 5.34281C23.0239 5.10444 23.4284 5.25497 23.4156 5.81743C23.4028 6.37989 22.2748 9.31242 20.1724 9.55893C18.07 9.80544 18.9592 6.3368 18.9592 6.3368Z'
        fill='#CB4DFF'
      />
      <path
        d='M11.9726 2C6.65522 2 2.3291 6.47696 2.3291 11.9798C2.3291 17.4826 6.65522 21.9596 11.9726 21.9596C17.2901 21.9596 21.6162 17.4828 21.6162 11.9798C21.6162 6.47675 17.2903 2 11.9726 2ZM11.9726 19.7007C7.85216 19.7007 4.51185 16.2439 4.51185 11.9798C4.51185 7.71565 7.85216 4.25886 11.9726 4.25886C16.0931 4.25886 19.4334 7.71562 19.4334 11.9798C19.4334 16.2439 16.0931 19.7007 11.9726 19.7007Z'
        fill='#AA6CDF'
      />
      <path
        d='M20.3203 11.5711C20.2492 11.6874 20.2143 11.8166 20.2132 11.9449C20.2121 12.0573 20.2362 12.1695 20.2842 12.2707C20.3386 12.3857 20.4238 12.4869 20.5361 12.5604C20.8594 12.7719 21.2873 12.6724 21.4919 12.3375C21.563 12.2212 21.5975 12.0916 21.599 11.9636C21.6007 11.8504 21.576 11.7391 21.5281 11.6378C21.4736 11.5229 21.3889 11.4219 21.2765 11.3484C21.1641 11.2749 21.0392 11.2387 20.9155 11.2371C20.6822 11.2342 20.4538 11.3524 20.3203 11.5711Z'
        fill='#FF6A76'
      />
      <path d='M20.5161 12.0452L20.9941 12.3579L21.2963 11.8632L20.8183 11.5505L20.5161 12.0452Z' fill='#FF1E76' />
      <path
        d='M20.9155 11.2371L20.8184 11.5506L21.2961 11.8631L21.5281 11.6378C21.4736 11.5228 21.3889 11.4218 21.2765 11.3483C21.1641 11.2748 21.0392 11.2387 20.9155 11.2371Z'
        fill='#FF4B76'
      />
      <path
        d='M21.5991 11.964L21.2961 11.8635L20.9941 12.3579L21.2118 12.598C21.3229 12.5416 21.4205 12.4539 21.4915 12.3376C21.5626 12.2213 21.5975 12.092 21.5991 11.964Z'
        fill='#FF4B76'
      />
      <path
        d='M20.8968 12.6714L20.9939 12.3579L20.5162 12.0454L20.2842 12.2707C20.3387 12.3856 20.4234 12.4866 20.5358 12.5602C20.6482 12.6337 20.7731 12.6698 20.8968 12.6714Z'
        fill='#FF4B76'
      />
      <path
        d='M20.2129 11.9445L20.5158 12.045L20.8178 11.5506L20.6001 11.3105C20.489 11.3669 20.3914 11.4546 20.3204 11.5709C20.2494 11.6872 20.2144 11.8165 20.2129 11.9445Z'
        fill='#FF4B76'
      />
      <path
        d='M21.2969 11.8633L21.5994 11.9635C21.601 11.8503 21.5764 11.7389 21.5284 11.6377L21.2969 11.8633Z'
        fill='#FFCAC0'
      />
      <path
        d='M20.2132 11.9448C20.2121 12.0571 20.2362 12.1694 20.2842 12.2706L20.5161 12.0453L20.2132 11.9448Z'
        fill='#FFCAC0'
      />
      <path
        d='M20.0532 14.6273C19.9729 14.6916 19.9152 14.7749 19.882 14.8667C19.8528 14.947 19.8418 15.034 19.8507 15.1197C19.8608 15.2169 19.8963 15.3126 19.9584 15.3957C20.137 15.6348 20.4692 15.6791 20.7006 15.4941C20.7809 15.4298 20.8384 15.3462 20.8718 15.2547C20.9016 15.1739 20.912 15.0873 20.9031 15.0017C20.8931 14.9045 20.8577 14.8091 20.7956 14.726C20.7336 14.6428 20.653 14.5831 20.5647 14.5485C20.3979 14.4834 20.2042 14.5065 20.0532 14.6273Z'
        fill='#FF6A76'
      />
      <path d='M20.0738 15.0207L20.3379 15.3743L20.6796 15.1009L20.4155 14.7473L20.0738 15.0207Z' fill='#FF1E76' />
      <path
        d='M20.5648 14.5486L20.416 14.7473L20.68 15.1007L20.9033 15.0018C20.8932 14.9045 20.8579 14.8091 20.7958 14.726C20.7337 14.6429 20.6532 14.5832 20.5648 14.5486Z'
        fill='#FF4B76'
      />
      <path
        d='M20.8714 15.2548L20.6794 15.1008L20.3379 15.374L20.4335 15.6051C20.5275 15.5947 20.6196 15.5582 20.7 15.4939C20.7803 15.4296 20.838 15.3463 20.8714 15.2548Z'
        fill='#FF4B76'
      />
      <path
        d='M20.1891 15.5729L20.3379 15.3742L20.0739 15.0208L19.8506 15.1197C19.8607 15.2169 19.896 15.3123 19.9581 15.3955C20.0202 15.4786 20.1007 15.5383 20.1891 15.5729Z'
        fill='#FF4B76'
      />
      <path
        d='M19.8818 14.8664L20.0739 15.0204L20.4154 14.7472L20.3197 14.5161C20.2258 14.5265 20.1336 14.5631 20.0533 14.6274C19.973 14.6916 19.9153 14.775 19.8818 14.8664Z'
        fill='#FF4B76'
      />
      <path
        d='M20.6797 15.101L20.8715 15.2547C20.9012 15.1739 20.9117 15.0873 20.9028 15.0017L20.6797 15.101Z'
        fill='#FFCAC0'
      />
      <path
        d='M19.882 14.8667C19.8528 14.947 19.8418 15.0341 19.8507 15.1197L20.074 15.0207L19.882 14.8667Z'
        fill='#FFCAC0'
      />
      <path
        d='M20.0532 9.28141C19.9729 9.21714 19.9152 9.13381 19.882 9.04205C19.8528 8.96174 19.8418 8.87468 19.8507 8.78906C19.8608 8.69184 19.8963 8.59616 19.9584 8.51302C20.137 8.27389 20.4692 8.2296 20.7006 8.41467C20.7809 8.47894 20.8384 8.56257 20.8718 8.65403C20.9016 8.7348 20.912 8.8214 20.9031 8.90702C20.8931 9.00423 20.8577 9.09962 20.7956 9.18276C20.7336 9.26589 20.653 9.32559 20.5647 9.36019C20.3979 9.42532 20.2042 9.40222 20.0532 9.28141Z'
        fill='#FF6A76'
      />
      <path d='M20.4156 9.16147L20.6797 8.80786L20.338 8.53452L20.0739 8.88814L20.4156 9.16147Z' fill='#FF1E76' />
      <path
        d='M20.5648 9.36025L20.416 9.16151L20.68 8.80811L20.9033 8.90708C20.8932 9.0043 20.8579 9.09969 20.7958 9.18282C20.7337 9.26596 20.6532 9.32565 20.5648 9.36025Z'
        fill='#FF4B76'
      />
      <path
        d='M20.8714 8.65376L20.6794 8.80777L20.3379 8.5346L20.4335 8.30347C20.5275 8.3139 20.6196 8.35045 20.7 8.41471C20.7803 8.47897 20.838 8.56231 20.8714 8.65376Z'
        fill='#FF4B76'
      />
      <path
        d='M20.1891 8.33594L20.3379 8.53468L20.0739 8.88808L19.8506 8.78911C19.8607 8.69189 19.896 8.5965 19.9581 8.51337C20.0202 8.43023 20.1007 8.37054 20.1891 8.33594Z'
        fill='#FF4B76'
      />
      <path
        d='M19.8818 9.0422L20.0739 8.88818L20.4154 9.16136L20.3197 9.39249C20.2258 9.38205 20.1336 9.34551 20.0533 9.28125C19.973 9.21699 19.9153 9.13365 19.8818 9.0422Z'
        fill='#FF4B76'
      />
      <path
        d='M20.6797 8.80777L20.8715 8.65405C20.9012 8.73483 20.9117 8.82143 20.9028 8.90704L20.6797 8.80777Z'
        fill='#FFCAC0'
      />
      <path
        d='M19.882 9.04205C19.8528 8.96174 19.8418 8.87468 19.8507 8.78906L20.074 8.88804L19.882 9.04205Z'
        fill='#FFCAC0'
      />
      <path
        d='M4.20651 14.6273C4.28684 14.6916 4.34453 14.7749 4.37773 14.8667C4.40688 14.947 4.41792 15.034 4.40903 15.1197C4.39895 15.2169 4.36341 15.3126 4.30131 15.3957C4.1227 15.6348 3.79047 15.6791 3.55911 15.4941C3.47877 15.4298 3.42131 15.3462 3.38788 15.2547C3.35815 15.1739 3.34769 15.0873 3.35658 15.0017C3.36666 14.9045 3.40198 14.8091 3.46407 14.726C3.52617 14.6428 3.6067 14.5831 3.69507 14.5485C3.86178 14.4834 4.05548 14.5065 4.20651 14.6273Z'
        fill='#FF6A76'
      />
      <path d='M3.84421 14.7472L3.58008 15.1008L3.92178 15.3742L4.18591 15.0206L3.84421 14.7472Z' fill='#FF1E76' />
      <path
        d='M3.69493 14.5486L3.84376 14.7473L3.57979 15.1007L3.35645 15.0018C3.36653 14.9045 3.40184 14.8091 3.46394 14.726C3.52603 14.6429 3.60656 14.5832 3.69493 14.5486Z'
        fill='#FF4B76'
      />
      <path
        d='M3.3877 15.2548L3.57974 15.1008L3.92124 15.374L3.8256 15.6051C3.73166 15.5947 3.63948 15.5582 3.55915 15.4939C3.47881 15.4296 3.42113 15.3463 3.3877 15.2548Z'
        fill='#FF4B76'
      />
      <path
        d='M4.0707 15.5729L3.92188 15.3742L4.18585 15.0208L4.40919 15.1197C4.39911 15.2169 4.36379 15.3123 4.3017 15.3955C4.2396 15.4786 4.15907 15.5383 4.0707 15.5729Z'
        fill='#FF4B76'
      />
      <path
        d='M4.37729 14.8664L4.18525 15.0204L3.84375 14.7472L3.93939 14.5161C4.03333 14.5265 4.12551 14.5631 4.20584 14.6274C4.28617 14.6916 4.34386 14.775 4.37729 14.8664Z'
        fill='#FF4B76'
      />
      <path
        d='M3.5797 15.101L3.38788 15.2547C3.35815 15.1739 3.34769 15.0873 3.35658 15.0017L3.5797 15.101Z'
        fill='#FFCAC0'
      />
      <path
        d='M4.37759 14.8667C4.40674 14.947 4.41778 15.0341 4.40889 15.1197L4.18555 15.0207L4.37759 14.8667Z'
        fill='#FFCAC0'
      />
      <path
        d='M3.9682 9.24481C4.04964 9.17966 4.10812 9.09519 4.14177 9.00217C4.17132 8.92076 4.18251 8.83251 4.1735 8.74571C4.16328 8.64716 4.12725 8.55016 4.0643 8.46589C3.88324 8.22348 3.54646 8.17858 3.31193 8.36619C3.23049 8.43134 3.17224 8.51612 3.13835 8.60883C3.10821 8.69071 3.09761 8.7785 3.10662 8.86529C3.11684 8.96384 3.15264 9.06053 3.21559 9.14481C3.27854 9.22908 3.36016 9.2896 3.44975 9.32467C3.61875 9.39069 3.8151 9.36728 3.9682 9.24481Z'
        fill='#FF6A76'
      />
      <path d='M3.94744 8.84626L3.67969 8.48779L3.3333 8.76488L3.60105 9.12334L3.94744 8.84626Z' fill='#FF1E76' />
      <path
        d='M3.44957 9.3246L3.60044 9.12314L3.33285 8.76489L3.10645 8.86522C3.11666 8.96377 3.15246 9.06047 3.21541 9.14474C3.27836 9.22902 3.35999 9.28954 3.44957 9.3246Z'
        fill='#FF4B76'
      />
      <path
        d='M3.13867 8.60851L3.33334 8.76464L3.67952 8.48772L3.58257 8.25342C3.48735 8.26399 3.39391 8.30104 3.31247 8.36618C3.23104 8.43133 3.17256 8.5158 3.13867 8.60851Z'
        fill='#FF4B76'
      />
      <path
        d='M3.83056 8.28638L3.67969 8.48784L3.94728 8.84609L4.17368 8.74576C4.16347 8.64721 4.12767 8.55051 4.06472 8.46624C4.00177 8.38196 3.92014 8.32144 3.83056 8.28638Z'
        fill='#FF4B76'
      />
      <path
        d='M4.14144 9.00232L3.94677 8.84619L3.60059 9.12311L3.69754 9.35741C3.79277 9.34684 3.8862 9.30979 3.96764 9.24465C4.04907 9.1795 4.10756 9.09503 4.14144 9.00232Z'
        fill='#FF4B76'
      />
      <path
        d='M3.3328 8.76471L3.13835 8.60889C3.10821 8.69077 3.09761 8.77856 3.10662 8.86535L3.3328 8.76471Z'
        fill='#FFCAC0'
      />
      <path
        d='M4.14194 9.00207C4.17149 8.92066 4.18268 8.8324 4.17367 8.74561L3.94727 8.84594L4.14194 9.00207Z'
        fill='#FFCAC0'
      />
      <path
        d='M11.9728 3.55103C7.47463 3.55103 3.82812 7.32467 3.82812 11.9797C3.82812 16.6347 7.47463 20.4084 11.9728 20.4084C16.471 20.4084 20.1175 16.6347 20.1175 11.9797C20.1175 7.32469 16.471 3.55103 11.9728 3.55103ZM11.9728 19.7006C7.85234 19.7006 4.51203 16.2438 4.51203 11.9797C4.51203 7.71557 7.85234 4.25878 11.9728 4.25878C16.0933 4.25878 19.4336 7.71555 19.4336 11.9797C19.4336 16.2439 16.0933 19.7006 11.9728 19.7006Z'
        fill='#6406EA'
      />
      <path
        d='M11.9728 20.4963C7.43497 20.4963 3.74316 16.6758 3.74316 11.9797C3.74316 7.28361 7.43497 3.46313 11.9728 3.46313C16.5106 3.46313 20.2024 7.28365 20.2024 11.9797C20.2024 16.6758 16.5106 20.4963 11.9728 20.4963ZM11.9728 3.6389C7.5286 3.6389 3.91301 7.38055 3.91301 11.9797C3.91301 16.5788 7.5286 20.3205 11.9728 20.3205C16.417 20.3205 20.0326 16.5788 20.0326 11.9797C20.0326 7.38055 16.417 3.6389 11.9728 3.6389Z'
        fill='currentColor'
      />
      <path
        d='M3.69772 12.3428C3.76973 12.2249 3.80512 12.0938 3.80628 11.9638L3.80654 11.9634C3.80767 11.8495 3.78298 11.7361 3.73434 11.6335C3.67912 11.517 3.59282 11.4144 3.47889 11.3398C3.15121 11.1255 2.7174 11.2263 2.51001 11.5659C2.438 11.6838 2.40301 11.8151 2.40144 11.9448C2.39979 12.0596 2.42474 12.1725 2.47339 12.2751C2.52861 12.3916 2.6145 12.494 2.72842 12.5685C2.84235 12.643 2.96898 12.6797 3.09437 12.6813C3.33089 12.6842 3.56234 12.5644 3.69772 12.3428Z'
        fill='#FF6A76'
      />
      <path d='M3.49922 11.8621L3.01465 11.5452L2.70836 12.0466L3.19293 12.3636L3.49922 11.8621Z' fill='#FF1E76' />
      <path
        d='M3.09462 12.6812L3.19307 12.3634L2.70879 12.0466L2.47363 12.275C2.52886 12.3915 2.61474 12.4939 2.72867 12.5684C2.8426 12.643 2.96922 12.6796 3.09462 12.6812Z'
        fill='#FF4B76'
      />
      <path
        d='M2.40137 11.9444L2.70846 12.0463L3.01457 11.5451L2.79389 11.3018C2.68129 11.3589 2.58236 11.4478 2.51035 11.5657C2.43834 11.6836 2.40294 11.8146 2.40137 11.9444Z'
        fill='#FF4B76'
      />
      <path
        d='M3.1131 11.2273L3.01465 11.5451L3.49893 11.8619L3.73408 11.6335C3.67886 11.517 3.59297 11.4146 3.47905 11.3401C3.36512 11.2656 3.23849 11.2289 3.1131 11.2273Z'
        fill='#FF4B76'
      />
      <path
        d='M3.80656 11.9642L3.49947 11.8623L3.19336 12.3635L3.41404 12.6068C3.52663 12.5497 3.62557 12.4608 3.69758 12.3429C3.76959 12.225 3.80498 12.094 3.80656 11.9642Z'
        fill='#FF4B76'
      />
      <path
        d='M2.70813 12.0464L2.40144 11.9448C2.39979 12.0595 2.42474 12.1725 2.47339 12.2751L2.70813 12.0464Z'
        fill='#FFCAC0'
      />
      <path
        d='M3.80612 11.9638L3.80638 11.9634C3.80751 11.8495 3.78282 11.7362 3.73418 11.6335L3.49902 11.8619L3.80612 11.9638Z'
        fill='#FFCAC0'
      />
      <path
        d='M15.3215 4.46348L14.9141 5.56169L14.8727 5.67313L14.7744 5.93836C14.7744 5.93836 12.9992 6.31571 12.1079 6.31571C11.2166 6.31571 9.32537 5.93836 9.32537 5.93836L9.23153 5.68533L9.18962 5.57245L8.77832 4.46348C8.87795 4.55579 8.98101 4.63388 9.08327 4.69534C9.15668 4.73947 9.22982 4.77498 9.30098 4.80105C9.33973 4.81528 9.37794 4.82676 9.41524 4.83525C9.55664 4.86742 9.68645 4.85797 9.79149 4.7995C9.90548 4.736 9.97585 4.51502 10.0043 4.22576C10.0209 4.05799 10.0234 3.86738 10.012 3.67103C10.064 3.7197 10.1177 3.76239 10.1722 3.79934C10.2539 3.85495 10.3377 3.89788 10.4212 3.92908C10.6945 4.03144 10.9645 4.0092 11.1518 3.90086C11.6338 3.62189 11.9857 3.02029 12.0419 2.23465L12.0499 2.23047L12.0579 2.23465C12.066 2.34706 12.0801 2.45575 12.0997 2.56027C12.2175 3.1859 12.535 3.66183 12.948 3.90086C13.095 3.98588 13.293 4.01793 13.5036 3.97811C13.6782 3.94535 13.8615 3.8632 14.0314 3.72102C14.0504 3.70511 14.0692 3.68837 14.0878 3.67103C14.0827 3.75952 14.0803 3.84681 14.081 3.93135C14.0835 4.35837 14.1581 4.71579 14.3083 4.79949C14.3345 4.81408 14.3622 4.82556 14.3913 4.83417C14.5338 4.87638 14.7084 4.84804 14.8909 4.76242C15.0335 4.69558 15.1809 4.59382 15.3215 4.46348Z'
        fill='#FFE600'
      />
      <path
        d='M14.8881 4.76619L14.5443 6.15187L13.1592 6.37051L13.5008 3.98188C13.6949 3.94541 13.8997 3.84795 14.085 3.6748C14.0659 4.00376 14.0855 4.31706 14.1455 4.5329C14.1831 4.66778 14.2362 4.76464 14.3055 4.80327C14.4058 4.85911 14.5286 4.87023 14.6626 4.84309C14.7351 4.82838 14.8109 4.80243 14.8881 4.76619Z'
        fill='#F9C432'
      />
      <g
        style={{
          mixBlendMode: 'darken',
        }}
      >
        <path
          d='M14.663 4.84303L14.3912 6.17603L13.7979 6.28922L14.1458 4.53296C14.1834 4.66784 14.2365 4.76458 14.3058 4.80321C14.4061 4.85905 14.5289 4.87017 14.663 4.84303Z'
          fill='#EF8C41'
        />
      </g>
      <path
        d='M12.0476 2.66239C12.2243 2.66239 12.3676 2.51411 12.3676 2.33119C12.3676 2.14828 12.2243 2 12.0476 2C11.8708 2 11.7275 2.14828 11.7275 2.33119C11.7275 2.51411 11.8708 2.66239 12.0476 2.66239Z'
        fill='#FFE600'
      />
      <path
        d='M12.3674 2.33118C12.3674 2.51414 12.2241 2.66242 12.0474 2.66242C11.9202 2.66242 11.8103 2.58565 11.7588 2.47444C11.8006 2.49524 11.8475 2.50684 11.897 2.50684C12.0738 2.50684 12.2171 2.35856 12.2171 2.17561C12.2171 2.12431 12.2058 2.07576 12.1857 2.03247C12.2932 2.08592 12.3674 2.19952 12.3674 2.33118Z'
        fill='#F9C432'
      />
      <path
        d='M11.9302 2.32198C11.9817 2.32198 12.0235 2.27876 12.0235 2.22544C12.0235 2.17213 11.9817 2.12891 11.9302 2.12891C11.8787 2.12891 11.8369 2.17213 11.8369 2.22544C11.8369 2.27876 11.8787 2.32198 11.9302 2.32198Z'
        fill='currentColor'
      />
      <path
        d='M12.4852 4.94799C12.4852 5.03958 12.4605 5.12518 12.417 5.19779C12.379 5.2614 12.3269 5.31569 12.2651 5.35499C12.1949 5.39962 12.1122 5.42527 12.0237 5.42527C11.7691 5.42527 11.5625 5.21177 11.5625 4.94799C11.5625 4.85639 11.5876 4.7708 11.6307 4.69819C11.6687 4.6339 11.7208 4.58028 11.7826 4.54098C11.8528 4.49635 11.9352 4.4707 12.0237 4.4707C12.1122 4.4707 12.1949 4.49635 12.2651 4.54098C12.3974 4.62524 12.4852 4.77579 12.4852 4.94799Z'
        fill='#F96EA4'
      />
      <path d='M12.2124 4.75317H11.8359V5.14276H12.2124V4.75317Z' fill='#DD226E' />
      <path
        d='M12.2647 4.54098L12.2116 4.75314H11.8353L11.7822 4.54098C11.8524 4.49635 11.9348 4.4707 12.0233 4.4707C12.1118 4.4707 12.1945 4.49635 12.2647 4.54098Z'
        fill='#EE4F85'
      />
      <path
        d='M11.6304 4.69824L11.8354 4.7532V5.14255L11.6304 5.19751C11.5873 5.1249 11.5625 5.03964 11.5625 4.94804C11.5625 4.85645 11.5873 4.77085 11.6304 4.69824Z'
        fill='#EE4F85'
      />
      <path
        d='M11.7822 5.35498L11.8353 5.14282H12.2116L12.2647 5.35498C12.1945 5.39961 12.1121 5.42526 12.0236 5.42526C11.9351 5.42526 11.8524 5.39961 11.7822 5.35498Z'
        fill='#EE4F85'
      />
      <path
        d='M12.4169 5.19751L12.2119 5.14255V4.7532L12.4169 4.69824C12.4601 4.77085 12.4848 4.85611 12.4848 4.94771C12.4848 5.0393 12.4601 5.1249 12.4169 5.19751Z'
        fill='#EE4F85'
      />
      <path
        d='M11.8356 4.75318L11.6309 4.69823C11.6688 4.63394 11.721 4.58032 11.7828 4.54102L11.8356 4.75318Z'
        fill='currentColor'
      />
      <path
        d='M12.4169 5.19778C12.3789 5.26139 12.3268 5.31568 12.265 5.35498L12.2119 5.14282L12.4169 5.19778Z'
        fill='currentColor'
      />
      <path
        d='M11.4121 3.9641C11.4121 3.9641 11.8394 3.69784 11.9603 3.00659C11.9603 3.00659 11.8438 3.97946 11.4121 3.9641Z'
        fill='#FFFFFD'
      />
      <path
        d='M14.0313 3.72089L13.9219 4.17254C13.9219 4.17254 13.3596 4.96296 13.4281 4.48787C13.4967 4.01279 13.2696 4.2578 12.7073 3.8547C12.2021 3.4925 12.1008 2.73521 12.0854 2.5849L12.083 2.55859L12.0996 2.56015C12.2174 3.18578 12.5349 3.66171 12.9479 3.90074C13.0949 3.98576 13.2929 4.01781 13.5035 3.97799C13.6781 3.94523 13.8615 3.86307 14.0313 3.72089Z'
        fill='#F9C432'
      />
      <g
        style={{
          mixBlendMode: 'darken',
        }}
      >
        <path
          d='M14.3908 4.83412C14.313 4.99232 14.2174 5.08153 14.1245 4.89462C13.9136 4.47036 14.0529 3.90894 14.0529 3.90894L14.0805 3.9313C14.083 4.35831 14.1576 4.71573 14.3078 4.79944C14.334 4.81403 14.3617 4.82551 14.3908 4.83412Z'
          fill='#EF8C41'
        />
      </g>
      <path
        d='M10.711 6.31564H10.479L10.1699 3.80298C10.2516 3.85858 10.3354 3.90151 10.4189 3.93272L10.711 6.31564Z'
        fill='#FFF8C2'
      />
      <path
        d='M9.93667 3.68611C10.0549 3.68611 10.1507 3.58696 10.1507 3.46464C10.1507 3.34232 10.0549 3.24316 9.93667 3.24316C9.81847 3.24316 9.72266 3.34232 9.72266 3.46464C9.72266 3.58696 9.81847 3.68611 9.93667 3.68611Z'
        fill='#FFE600'
      />
      <path
        d='M10.1511 3.46464C10.1511 3.58699 10.0553 3.68614 9.93716 3.68614C9.85209 3.68614 9.7786 3.63481 9.74414 3.56044C9.77211 3.57435 9.80348 3.58211 9.83655 3.58211C9.95478 3.58211 10.0506 3.48295 10.0506 3.36061C10.0506 3.3263 10.0431 3.29384 10.0297 3.26489C10.1015 3.30064 10.1511 3.3766 10.1511 3.46464Z'
        fill='#F9C432'
      />
      <path
        d='M9.85828 3.45846C9.89273 3.45846 9.92066 3.42955 9.92066 3.3939C9.92066 3.35825 9.89273 3.32935 9.85828 3.32935C9.82383 3.32935 9.7959 3.35825 9.7959 3.3939C9.7959 3.42955 9.82383 3.45846 9.85828 3.45846Z'
        fill='currentColor'
      />
      <path
        d='M14.1593 3.69222C14.2775 3.69222 14.3733 3.59306 14.3733 3.47074C14.3733 3.34843 14.2775 3.24927 14.1593 3.24927C14.0411 3.24927 13.9453 3.34843 13.9453 3.47074C13.9453 3.59306 14.0411 3.69222 14.1593 3.69222Z'
        fill='#FFE600'
      />
      <path
        d='M14.3738 3.47075C14.3738 3.59309 14.278 3.69225 14.1598 3.69225C14.0747 3.69225 14.0013 3.64091 13.9668 3.56654C13.9948 3.58046 14.0261 3.58821 14.0592 3.58821C14.1774 3.58821 14.2732 3.48906 14.2732 3.36671C14.2732 3.33241 14.2658 3.29994 14.2523 3.271C14.3242 3.30674 14.3738 3.38271 14.3738 3.47075Z'
        fill='#F9C432'
      />
      <path
        d='M14.0809 3.4648C14.1154 3.4648 14.1433 3.4359 14.1433 3.40025C14.1433 3.3646 14.1154 3.33569 14.0809 3.33569C14.0465 3.33569 14.0186 3.3646 14.0186 3.40025C14.0186 3.4359 14.0465 3.4648 14.0809 3.4648Z'
        fill='currentColor'
      />
      <path
        d='M10.0022 4.22949C9.97378 4.51875 9.90341 4.73973 9.78941 4.80323C9.71465 4.84486 9.62732 4.86166 9.53223 4.85627C9.62553 5.20048 9.78954 5.88849 9.87892 6.21732L10.3413 6.31575L10.0022 4.22949Z'
        fill='#FCB400'
      />
      <path
        d='M9.77115 6.16358H9.66651L9.29883 4.80469C9.33757 4.81892 9.37579 4.8304 9.41308 4.83889L9.77115 6.16358Z'
        fill='#FFF8C2'
      />
      <g
        style={{
          mixBlendMode: 'darken',
        }}
      >
        <path
          d='M9.25897 6.03954C9.21886 6.0122 9.20542 5.96298 9.22143 5.91984L9.2379 5.87548C9.41937 6.10495 10.6112 6.28217 12.0542 6.28217C13.5228 6.28217 14.731 6.09861 14.8791 5.86328L14.8974 5.91257C14.9128 5.95417 14.9012 6.00171 14.8636 6.02938C14.5431 6.26557 13.4068 6.44012 12.0542 6.44012C10.721 6.44012 9.5979 6.27058 9.25897 6.03954Z'
          fill='#EF8C41'
        />
      </g>
      <path
        d='M9.19727 5.82378C9.19727 5.78229 9.22139 5.74187 9.26712 5.70312C9.25974 5.71687 9.25605 5.73075 9.25605 5.74486C9.25605 6.00315 10.506 6.21253 12.0479 6.21253C13.5898 6.21253 14.8398 6.00315 14.8398 5.74486C14.8398 5.73075 14.8361 5.71688 14.8287 5.70312C14.8745 5.74187 14.8986 5.78229 14.8986 5.82378C14.8986 6.12572 13.6224 6.3705 12.0479 6.3705C10.4735 6.3705 9.19727 6.12572 9.19727 5.82378Z'
        fill='#F4CE52'
      />
      <path
        d='M9.21387 5.68988C9.21387 5.67631 9.21729 5.66286 9.22415 5.64966C9.34724 5.89244 10.5674 6.08301 12.0541 6.08301C13.5409 6.08301 14.761 5.89244 14.8841 5.64966C14.8909 5.66286 14.8943 5.67631 14.8943 5.68988C14.8943 5.95156 13.6227 6.16369 12.0541 6.16369C10.4856 6.16369 9.21387 5.95156 9.21387 5.68988Z'
        fill='#F2B640'
      />
      <path
        d='M14.6748 21.4697V19.3887C15.5945 19.4126 16.4092 19.4257 17.154 19.7222L16.4967 20.4971L17.154 21.9916C16.1281 21.5251 15.3665 21.4697 14.6748 21.4697Z'
        fill='#3953E2'
      />
      <path
        d='M9.27115 21.4697V19.3887C8.3515 19.4126 7.5368 19.4257 6.79199 19.7222L7.44928 20.4971L6.79199 21.9916C7.81785 21.5251 8.57947 21.4697 9.27115 21.4697Z'
        fill='#3953E2'
      />
      <path
        d='M11.9724 21.3111C10.9494 21.3111 9.67802 21.4956 8.16504 21.9992V19.0855C9.78702 18.6518 10.9595 18.5151 11.9724 18.5151C12.9852 18.5151 14.225 18.6648 15.7814 19.086V22C14.2999 21.5696 12.9953 21.3111 11.9724 21.3111Z'
        fill='#5560FF'
      />
      <path
        d='M9.73968 20.5912C10.2004 20.1641 10.4732 19.8344 10.4732 19.564C10.4732 19.3861 10.3792 19.2793 10.2188 19.2793C10.095 19.2793 9.99184 19.3624 9.90704 19.4596L9.72363 19.2699C9.8795 19.0991 10.0308 19.0042 10.2623 19.0042C10.5833 19.0042 10.7964 19.2177 10.7964 19.545C10.7964 19.8629 10.542 20.2045 10.2325 20.5176C10.3173 20.5081 10.4297 20.4987 10.5076 20.4987H10.8767V20.7928H9.73968V20.5912Z'
        fill='currentColor'
      />
      <path
        d='M11.2002 19.0374H11.5463L12.0392 19.972L12.2088 20.3516H12.2203C12.2019 20.1689 12.1767 19.9364 12.1767 19.7372V19.0374H12.4976V20.7928H12.1538L11.6632 19.8534L11.4913 19.4762H11.4798C11.4959 19.666 11.5211 19.8866 11.5211 20.0883V20.7928H11.2002L11.2002 19.0374Z'
        fill='currentColor'
      />
      <path
        d='M12.918 19.0374H13.3833C13.9013 19.0374 14.2223 19.3149 14.2223 19.9079C14.2223 20.4987 13.9013 20.7928 13.4016 20.7928H12.918L12.918 19.0374ZM13.3626 20.5105C13.679 20.5105 13.8761 20.3349 13.8761 19.9079C13.8761 19.4786 13.679 19.3173 13.3626 19.3173H13.2572V20.5105L13.3626 20.5105Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_2049_19659'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFanRanking02;
